import PostsMetaModel from "./PostsMetaModel";
import PostByIdBasicModel from "./PostByIdBasicModel";

export default class PostsDiscussionBasicModel {
  public meta: PostsMetaModel = new PostsMetaModel();
  public data: PostByIdBasicModel[] = [];
}
